import { useLanguage } from "@/i18n/LanguageContext";

const SPEC_KEYS = [
  ["thickness", "540 microns"],
  ["maxHeight", "3200 mm"],
  ["maxWidth", "1520 mm"],
  ["uv", "> 99%"],
  ["ir", "> 90%"],
  ["transOn", "> 82%"],
  ["transOff", "> 50%"],
  ["temp", "-20°C → 70°C"],
  ["voltage", "220V / 50Hz"],
  ["consumption", "~ 5 W / m²"],
  ["response", "< 20 ms"],
  ["lifespan", "> 50 000 h"],
];

export const Specifications = () => {
  const { t } = useLanguage();
  return (
    <section
      id="specifications"
      data-testid="specifications-section"
      className="py-20 sm:py-32 lg:py-40 bg-[#0a0a0a] relative"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 sm:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs uppercase tracking-[0.32em] text-[#d89557]">{t("specs.label")}</span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#f4ede0] mt-4 sm:mt-6 leading-tight">
              {t("specs.title1")} <span className="italic copper-text">{t("specs.title2")}</span>{" "}
              {t("specs.title3")}
            </h2>
            <p className="text-[#cbc1ad] mt-8 leading-relaxed">{t("specs.desc")}</p>
            <div className="mt-10 inline-flex flex-col gap-3">
              <a href="#" className="text-xs uppercase tracking-[0.25em] text-[#d89557] hover:text-[#f3c98a] transition border-b border-[#b87333]/40 pb-1">
                {t("specs.pdf")}
              </a>
              <a href="#" className="text-xs uppercase tracking-[0.25em] text-[#d89557] hover:text-[#f3c98a] transition border-b border-[#b87333]/40 pb-1">
                {t("specs.manual")}
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-[#2a2422]">
              {SPEC_KEYS.map(([key, value]) => (
                <div
                  key={key}
                  data-testid={`spec-${key}`}
                  className="bg-[#0d0c0b] p-6 hover:bg-[#161514] transition group"
                >
                  <div className="text-[10px] uppercase tracking-[0.25em] text-[#7a716a] mb-3 group-hover:text-[#d89557] transition">
                    {t(`specs.items.${key}`)}
                  </div>
                  <div className="font-display text-2xl text-[#f4ede0]">{value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
